import axios from "axios";

export default async function fetchIconsData() {
  const url = `${process.env.NEXT_PUBLIC_ICON_CDN}?q=${new Date().getTime()}`;
  let result = null;
  const res = await axios({
    method: "get",
    url,
  });
  if (res.status === 200) {
    result = res.data;
    return result;
  }
  return result;
}
